import React from 'react';

export default function SelectCell({ value, checkTest }) {
  return (
    <span>
      {checkTest && checkTest.length === 2 && (
        <i className={checkTest[0]} style={{ color: checkTest[1], marginRight: 4 }} />
      )}
      {value || ''}
    </span>
  );
}
